import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="bqiw3nuwu4ts">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-36" data-mp="195wujiubu1cl">
          <div className="mx-auto max-w-xl" data-id="element-37" data-mp="2f5vcd1fcvhin">
            <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-xl bg-brand px-4 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-ink shadow-[0_4px_0_#a16207]" data-id="element-38" data-mp="21dfdmcthm5nj">
              <span className="whitespace-nowrap" data-id="element-39" data-mp="1wdazgtg1xn0h">Get Instant Access — $27</span>
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-40" data-mp="1wb6m7kw9jbnj" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}